/*
 * New Lead Profile
 */
import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import {
  Close as IconClose,
  Image as DemoImage,
  Info as InfoIcon,
} from "@mui/icons-material";

import TxtRow from "components/Custom/TxtRow";
import Btn from "components/Custom/Btn";
import RadioBtn from "components/Custom/RadioBtn";
import TxtBox from "components/Custom/TxtBox";
import SkeletonBox from "components/Custom/SkeletonBox";
import UiDialog from "components/Custom/UiDialog";

import { LABELS, SUCCESS, WARNINGS } from "common/lables";
import { COLORS } from "common/colors";
import {
  API_CONFIG,
  CONFIG,
  CRM_LEAD_STATUS,
  FORMATS,
  NOTIFY,
} from "common/config";
import { DateFunctions } from "common/datefunctions";
import { COMMON_JS } from "common/scripts";

import { CRM_APIs } from "apihandlers/crm";
import { AUTH_APIs } from "apihandlers/auth";
import { CUSTOMER_APIs } from "apihandlers/customer";
import { GEO_APIs } from "apihandlers/geography";
import AutoComplete from "components/Custom/AutoComplete";

import Comments from "../../Comments";
import StatusButtons from "../../StatusButtons";
import { on } from "events";

const thumbnailImg = require("assets/images/pdf.png");

interface defaultProps {
  setManageNewDialog;
  selectedRow;
}

const NewDealer = (props: any) => {
  const {
    setManageNewDialog,
    selectedRow,
    onClose,
    isButtonDisabled,
    remarksList,
    getCrmRemarks,
    remarksLoading,
    setRemarksLoading,
    isApproved,
  } = props;
  const godownVerificationDetails = selectedRow.godownVerificationDetails
    ? JSON.parse(selectedRow.godownVerificationDetails)
    : {};
  const logisticsVerificationDetails = selectedRow.logisticsVerificationDetails
    ? JSON.parse(selectedRow.logisticsVerificationDetails)
    : {};
  const accessVerificationDetails = selectedRow.accessVerificationDetails
    ? JSON.parse(selectedRow.accessVerificationDetails)
    : {};
  const techVerificationDetails = selectedRow.techVerificationDetails
    ? JSON.parse(selectedRow.techVerificationDetails)
    : {};
  const workModeVerificationDetails = selectedRow.workModeVerificationDetails
    ? JSON.parse(selectedRow.workModeVerificationDetails)
    : {};
  const financeVerificationDetails = selectedRow.financeVerificationDetails
    ? JSON.parse(selectedRow.financeVerificationDetails)
    : {};
  const firstOrderDetails = selectedRow.firstOrderDetails
    ? JSON.parse(selectedRow.firstOrderDetails)
    : {};
  const companyDetails = selectedRow.companyDetails
    ? JSON.parse(selectedRow.companyDetails)
    : {};
  const currentDetails = selectedRow.currentDetails
    ? JSON.parse(selectedRow.currentDetails)
    : {};
  const personalDetails = selectedRow.personalDetails
    ? JSON.parse(selectedRow.personalDetails)
    : {};
  const storageDetails = selectedRow.storageDetails
    ? JSON.parse(selectedRow.storageDetails)
    : {};

  const [isSubmit, setIsSubmit] = useState(false);
  const [storeVisitFiles, setStoreVisitFiles] = useState<any>(
    godownVerificationDetails.files || []
  );
  const [logisticsVerificationFiles, setLogisticsVerificationFiles] =
    useState<any>(logisticsVerificationDetails.files || []);
  const [uploading, setUploading] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [assignedInfo, setAssignedInfo] = useState<any>({});
  const [uploadingLogistic, setUploadingLogistic] = useState<boolean>(false);
  const [isVehicle, setIsVehicle] = useState<any>(
    logisticsVerificationDetails.VehicalStatus || " "
  );
  const [godownDemoDialog, setGodownDemoDialog] = useState<boolean>(false);
  const [logisticsDemoDialog, setLogisticsDemoDialog] =
    useState<boolean>(false);
  const [states, setStates] = useState<any>([]);
  const [district, setDistrict] = useState<any>([]);
  const [city, setCity] = useState<any>([]);
  const [zone, setZone] = useState<any>([]);
  const [taluka, setTaluka] = useState<any>([]);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  const agencyDetailsDistrictRef: any = useRef(null);
  const agencyDetailsStateRef: any = useRef(null);
  const agencyDetailsCityRef: any = useRef(null);
  const agencyDetailsZoneRef: any = useRef(null);
  const agencyTalukaRef: any = useRef(null);

  useEffect(() => {
    if (loading) {
      getAssignedInfo();
    }
  }, [loading]);

  const getAssignedInfo = async () => {
    try {
      const res: any = await CUSTOMER_APIs.getCrmLeadAssigned({
        crmLeadId: selectedRow.id,
      });
      console.log("getCrmLeadAssigned:", res);
      if (res.status === 200) {
        const records = res.response.records;
        if (records.length > 0) {
          setAssignedInfo(records[0]);
          getStates();
        }
      }
    } catch (error) {
      console.error("getCrmLeadAssigned:", error);
    }
  };

  const getStates = async () => {
    try {
      const res: any = await GEO_APIs.getStates({ activeStatus: "true" });
      const stateList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.stateName,
        };
      });
      setStates(stateList);
      if (selectedRow.id) {
        // load districts
        // if (companyDetails.compState) {
        //   let selectedAgencyState = null;
        //   if (companyDetails.compState) {
        //     selectedAgencyState = allStates.find(
        //       (s) => s.id === companyDetails.compState
        //     );
        //     setStates(selectedAgencyState);
        //   }
        // }
        if (companyDetails.compState) {
          const list = await getDistricts(companyDetails.compState);
          setDistrict(list);
        }
        if (companyDetails.compDist) {
          const list = await getRegions(companyDetails.compDist);
          setTaluka(list);
        }
        if (companyDetails.compTaluka) {
          const list = await getCity(companyDetails.compTaluka);
          setCity(list);
        }
        //zone
        if (companyDetails.compState) {
          const list = await getZone(companyDetails.compState);
          setZone(list);
        }
      }
      setLoading(false);
    } catch (error) {}
  };

  const getDistricts = async (stateId) => {
    let districtList = [];
    try {
      const args = {
        stateId,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getDistricts(args);
      districtList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.districtName,
        };
      });
    } catch (error) {}
    return districtList;
  };

  const getRegions = async (districtId) => {
    let regionList = [];
    try {
      const args = {
        districtId,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getRegions(args);
      regionList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.regionName,
        };
      });
    } catch (error) {}
    return regionList;
  };
  const getZone = async (stateId) => {
    let zoneList = [];
    try {
      const args = {
        stateId,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getRegionZones(args);
      zoneList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.regionZoneName,
        };
      });
    } catch (error) {}
    return zoneList;
  };
  const getCity = async (talukId) => {
    let cityList = [];
    try {
      const args = {
        talukId,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getCities(args);
      cityList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.cityName,
        };
      });
    } catch (error) {}
    return cityList;
  };
  const saveRecord = async () => {
    try {
      // Agency Details
      const firmName = (
        document.getElementById("firmName") as HTMLInputElement
      ).value.trim();
      const city = agencyDetailsCityRef.current.selectedValue
        ? agencyDetailsCityRef.current.selectedValue.id
        : "";

      const taluka = agencyTalukaRef.current.selectedValue
        ? agencyTalukaRef.current.selectedValue.id
        : "";
      // const taluka = (
      //   document.getElementById("taluka") as HTMLInputElement
      // ).value.trim();
      const state = agencyDetailsStateRef.current.selectedValue
        ? agencyDetailsStateRef.current.selectedValue.id
        : "";

      const district = agencyDetailsDistrictRef.current.selectedValue
        ? agencyDetailsDistrictRef.current.selectedValue.id
        : "";

      const zone = agencyDetailsZoneRef.current.selectedValue
        ? agencyDetailsZoneRef.current.selectedValue.id
        : "";
      const population = (
        document.getElementById("population") as HTMLInputElement
      ).value.trim();
      let type = document.querySelector(
        'input[name="firmType"]:checked'
      ) as HTMLInputElement;
      const firmType = type ? type.value : "";

      // Contact Person

      // Phy Godown Verification
      let manPowerEle = document.querySelector(
        'input[name="manPowerPlanning"]:checked'
      ) as HTMLInputElement;
      const manPowerPlanning = manPowerEle ? manPowerEle.value : "";
      let phyGodown = document.querySelector(
        'input[name="GodownStatus"]:checked'
      ) as HTMLInputElement;
      const GodownStatus = phyGodown ? phyGodown.value : "";
      let phyOwner = document.querySelector(
        'input[name="OwnerStatus"]:checked'
      ) as HTMLInputElement;
      const OwnerStatus = phyOwner ? phyOwner.value : "";
      const godownSize = (
        document.getElementById("godownSize") as HTMLInputElement
      ).value.trim();

      // Logistic Verification
      let phyVehical = document.querySelector(
        'input[name="VehicalStatus"]:checked'
      ) as HTMLInputElement;
      const VehicalStatus = phyVehical ? phyVehical.value : "";
      let phyVehicalOwner = document.querySelector(
        'input[name="VehicleOwnerStatus"]:checked'
      ) as HTMLInputElement;
      const VehicleOwnerStatus = phyVehicalOwner ? phyVehicalOwner.value : "";
      let phyVehicalType = document.querySelector(
        'input[name="VehicleTypeStatus"]:checked'
      ) as HTMLInputElement;
      const VehicleTypeStatus = phyVehicalType ? phyVehicalType.value : "";
      let noOfVehicle: any = document.getElementById(
        "noOfVehicle"
      ) as HTMLInputElement;
      if (noOfVehicle) {
        noOfVehicle = noOfVehicle.value.trim();
      } else {
        noOfVehicle = "";
      }

      let noOfRentedVehicle: any = document.getElementById(
        "noOfRentedVehicle"
      ) as HTMLInputElement;
      if (noOfRentedVehicle) {
        noOfRentedVehicle = noOfRentedVehicle.value.trim();
      } else {
        noOfRentedVehicle = "";
      }
      let packBody: any = document.getElementById(
        "packBody"
      ) as HTMLInputElement;
      if (packBody) {
        packBody = packBody.value.trim();
      } else {
        packBody = "";
      }

      // Access Verification
      let access = document.querySelector(
        'input[name="AccessStatus"]:checked'
      ) as HTMLInputElement;
      const AccessStatus = access ? access.value : "";
      const accessReason = (
        document.getElementById("accessReason") as HTMLInputElement
      ).value.trim();

      // Tech Verification
      let tech = document.querySelector(
        'input[name="TechStatus"]:checked'
      ) as HTMLInputElement;
      const TechStatus = tech ? tech.value : "";

      let printStatus = document.querySelector(
        'input[name="printerStatus"]:checked'
      ) as HTMLInputElement;
      const printerStatus = printStatus ? printStatus.value : "";

      let online = document.querySelector(
        'input[name="OnlineStatus"]:checked'
      ) as HTMLInputElement;
      const OnlineStatus = online ? online.value : "";
      const onlineDate = (
        document.getElementById("onlineDate") as HTMLInputElement
      ).value.trim();
      let weekly = document.querySelector(
        'input[name="WeeklyStatus"]:checked'
      ) as HTMLInputElement;
      const WeeklyStatus = weekly ? weekly.value : "";

      // Work Mode Verification
      let work = document.querySelector(
        'input[name="WorkModeStatus"]:checked'
      ) as HTMLInputElement;
      const WorkModeStatus = work ? work.value : "";
      const workCondition = (
        document.getElementById("workCondition") as HTMLInputElement
      ).value.trim();
      const agencyName = (
        document.getElementById("agencyName") as HTMLInputElement
      ).value.trim();

      // Finance Verification
      let finance = document.querySelector(
        'input[name="FinanceStatus"]:checked'
      ) as HTMLInputElement;
      const FinanceStatus = finance ? finance.value : "";
      const investCapacity = (
        document.getElementById("investCapacity") as HTMLInputElement
      ).value.trim();
      const familyMembers = (
        document.getElementById("familyMembers") as HTMLInputElement
      ).value.trim();
      let business = document.querySelector(
        'input[name="BusinessStatus"]:checked'
      ) as HTMLInputElement;
      const BusinessStatus = business ? business.value : "";

      const yearly = (
        document.getElementById("yearly") as HTMLInputElement
      ).value.trim();

      // First Order Detail
      const firstOrderName = (
        document.getElementById("firstOrderName") as HTMLInputElement
      ).value.trim();
      const firstOrderDate = (
        document.getElementById("firstOrderDate") as HTMLInputElement
      ).value.trim();
      const firstOrderDesignantion = (
        document.getElementById("firstOrderDesignantion") as HTMLInputElement
      ).value.trim();

      const mobileNo = (
        document.getElementById("mobileNo") as HTMLInputElement
      ).value.trim();
      const remarks = (
        document.getElementById("remarks") as HTMLInputElement
      ).value.trim();
      const followupDate = (
        document.getElementById("followupDate") as HTMLInputElement
      ).value.trim();

      const argsAgencyDetails = {
        city,
        zone,
        population,
      };
      const argsContactPerson = {
        phone: mobileNo,
      };
      const argsPhysicalGodown = {
        GodownStatus,
        OwnerStatus,
        godownSize,
        files: storeVisitFiles,
        manPowerPlanning,
      };
      const argsLogistics = {
        VehicalStatus,
        VehicleOwnerStatus,
        VehicleTypeStatus, // disabled={isButtonDisabled}
        noOfVehicle,
        packBody,
        files: logisticsVerificationFiles,
        noOfRentedVehicle,
      };
      const argsAccess = {
        AccessStatus,
        accessReason,
      };
      const argsTech = {
        TechStatus,
        OnlineStatus,
        onlineDate,
        WeeklyStatus,
        printerStatus,
      };
      const argsWorkMode = {
        WorkModeStatus,
        workCondition,
        agencyName,
      };
      const argsFinance = {
        FinanceStatus,
        investCapacity,
        familyMembers,
        BusinessStatus,
        yearly,
        name: firstOrderName,
        businessDesignation: firstOrderDesignantion,
      };
      const argsFirstOrder = {
        firstOrderName,
        firstOrderDate,
        firstOrderDesignantion,
      };

      // const argsRemarks = {
      //   ...selectedRemarks,
      //   fieldVisit: remarks,
      // };
      let argsRemarks = [];
      if (remarks) {
        argsRemarks = remarksList
          ? [...remarksList, { followupDate: followupDate, remarks: remarks }]
          : [{ followupDate: followupDate, remarks: remarks }];
      }

      const args = {
        crmLeadId: selectedRow.id,
        crmLeadStatus: CRM_LEAD_STATUS.FIELD_VISIT,
        // crmLeadStatus: selectedRow.crmLeadStatus,
        crmLeadName: selectedRow.crmLeadName,
        activeStatus: selectedRow.activeStatus,
        currentDetails: {
          ...JSON.parse(selectedRow.currentDetails),
          ...argsAgencyDetails,
        },
        personalDetails: {
          ...JSON.parse(selectedRow.personalDetails),
          ...argsContactPerson,
        },
        companyDetails: {
          ...JSON.parse(selectedRow.companyDetails),
          compName: firmName,
          compTaluka: taluka,
          compDist: district,
          compState: state,
          firmType,
        },
        firstOrderDetails: argsFirstOrder,
        logisticsVerificationDetails: argsLogistics,
        accessVerificationDetails: argsAccess,
        godownVerificationDetails: argsPhysicalGodown,
        storageDetails: {
          ...JSON.parse(selectedRow.storageDetails),
          godownSize,
        },
        techVerificationDetails: argsTech,
        workModeVerificationDetails: argsWorkMode,
        financeVerificationDetails: argsFinance,
        remarks: argsRemarks,
      };

      let errors = [];
      var regMobile = /^[1-9]\d{9}$/;

      if (mobileNo) {
        if (!regMobile.test(mobileNo)) {
          errors.push({
            id: "mobileNo",
            msg: "Plese Enter Valid Phone Number",
          });
        }
      }
      if (!GodownStatus) {
        errors.push({
          id: "GodownStatus",
          msg:
            "<span class='bold'>" +
            "Physical godown verification" +
            "</span> " +
            WARNINGS.IS_A_REQUIRED_FIELD,
        });
      }
      if (!OwnerStatus) {
        errors.push({
          id: "OwnerStatus",
          msg:
            "<span class='bold'>" +
            LABELS.PHYSICAL_GODOWN_TYPE +
            "</span> " +
            WARNINGS.IS_A_REQUIRED_FIELD,
        });
      }
      if (!godownSize) {
        errors.push({
          id: "godownSize",
          msg:
            "<span class='bold'>" +
            LABELS.GODOWN_SIZE +
            "</span> " +
            WARNINGS.IS_A_REQUIRED_FIELD,
        });
      }
      if (!manPowerPlanning) {
        errors.push({
          id: "manPowerPlanning",
          msg:
            "<span class='bold'>" +
            "Manpower Planning" +
            "</span> " +
            WARNINGS.IS_A_REQUIRED_FIELD,
        });
      }
      if (!AccessStatus) {
        errors.push({
          id: "AccessStatus",
          msg:
            "<span class='bold'>" +
            "Company / transport vehicle reachable to godown ?" +
            "</span> " +
            WARNINGS.IS_A_REQUIRED_FIELD,
        });
      }
      // if (!accessReason) {
      //   errors.push({
      //     id: "accessReason",
      //     msg:
      //       "<span class='bold'>" +
      //       "Physical Godown Verification (wire obstruction, water clogging etc)" +
      //       "</span> " +
      //       WARNINGS.IS_A_REQUIRED_FIELD,
      //   });
      // }
      if (storeVisitFiles.length === 0) {
        errors.push({
          id: "storeVisitFiles",
          msg:
            "<span class='bold'>" +
            "Physical Godown Verification File" +
            "</span> " +
            WARNINGS.IS_A_REQUIRED_FIELD,
        });
      }
      setMandatoryResults(errors);
      if (errors.length > 0) {
        COMMON_JS.showNotify(
          props,
          NOTIFY.WARNING,
          WARNINGS.PLEASE_CHECK_FORM_ERRORS
        );
        return;
      }

      setIsSubmit(true);
      const res: any = await CRM_APIs.manageCrmLeadProfile(args);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        onClose();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, "Error: " + res.error);
      }
      setIsSubmit(false);
      console.log("saveRecord: ", args, res);
    } catch (error) {
      setIsSubmit(false);
      console.log("saveRecord: error:", error);
    }
  };

  const onUploadFile = (e: any, f: any, field) => {
    console.log("onUploadFile: ", e, f, field);
    const file: any = e.target.files[0];
    if (file.size / 1024 / 1024 > CONFIG.MAX_FILE_SIZE) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.FILE_SIZE_EXCEEDED);
      return;
    }
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let base64: any = reader.result;
      if (field === "godownVerification") {
        setStoreVisitFiles(null);
        setUploading(true);
      } else {
        setLogisticsVerificationFiles(null);
        setUploadingLogistic(true);
      }

      uploadFile(file, base64).then((res) => {
        if (field === "godownVerification") {
          setStoreVisitFiles([...storeVisitFiles, res]);
          setUploading(false);
        } else if (field === "logisticVerification") {
          setLogisticsVerificationFiles([...logisticsVerificationFiles, res]);
          setUploadingLogistic(false);
        }
      });
    };
    reader.onerror = (error) => {
      console.log("uploadFile: Error:", error);
    };
  };

  const uploadFile = async (file: any, base64 = "") => {
    const args = {
      recordRefId: 1,
      file: {
        name: file.name,
        data: base64.replace("data:", "").replace(/^.+,/, ""),
        type: file.type,
        mimeType: file.name.split(".")[1],
        size: file.size,
      },
      category: "storevisit",
    };
    let fileInfo = null;
    try {
      const res = await AUTH_APIs.fileUpload(args);
      const response: any = res.response;
      if (res.status === 200) {
        fileInfo = response;
        fileInfo["mimeType"] = args.file.mimeType;
        (document.getElementById("uploadFile") as HTMLInputElement).value =
          null;
      }
    } catch (error) {}
    return fileInfo;
  };
  const selectedRemarks = selectedRow.remarks
    ? JSON.parse(selectedRow.remarks)
    : {};

  const onStateChange = async (e, f) => {
    if (f.id) {
      const res = await getDistricts(f.id);
      setDistrict(res);
      handleZone(f.id);
    }
  };

  const handleZone = async (f) => {
    if (f) {
      const res = await getZone(f);
      setZone(res);
    }
  };
  const onDistrictChange = async (e, f) => {
    if (f.id) {
      const res = await getRegions(f.id);
      setTaluka(res);
    }
  };
  const onTalukaChange = async (e, f) => {
    if (f.id) {
      const res = await getCity(f.id);
      setCity(res);
    }
  };

  let selectedAgencyState = null;
  if (companyDetails.compState) {
    selectedAgencyState = states.find((s) => s.id === companyDetails.compState);
    if (!selectedAgencyState) {
      selectedAgencyState = null;
    }
  }

  let selectedAgencyDistrict = null;
  if (companyDetails.compDist) {
    selectedAgencyDistrict = district.find(
      (s) => s.id === companyDetails.compDist
    );
    if (!selectedAgencyDistrict) {
      selectedAgencyDistrict = null;
    }
  }

  let selectedAgencyTaluka = null;
  if (companyDetails.compTaluka) {
    selectedAgencyTaluka = taluka.find(
      (s) => s.id === companyDetails.compTaluka
    );
    if (!selectedAgencyTaluka) {
      selectedAgencyTaluka = null;
    }
  }

  let selectedAgencyCity = null;
  if (currentDetails.city) {
    selectedAgencyCity = city.find((s) => s.id === currentDetails.city);
    if (!selectedAgencyCity) {
      selectedAgencyCity = null;
    }
  }
  let selectedAgencyZone = null;
  if (currentDetails.zone) {
    selectedAgencyZone = zone.find((s) => s.id === currentDetails.zone);
    if (!selectedAgencyZone) {
      selectedAgencyZone = null;
    }
  }

  // console.log("selected row", selectedRow);
  // console.log("selected row", companyDetails, district, selectedAgencyDistrict);
  console.log("selected row", isApproved);

  return loading ? (
    <div>
      <SkeletonBox
        height={250}
        width={"98%"}
        style={{ borderRadius: 5, marginBottom: 25 }}
      />
      <SkeletonBox
        height={250}
        width={"98%"}
        style={{ borderRadius: 5, marginBottom: 25 }}
      />
      <SkeletonBox
        height={250}
        width={"98%"}
        style={{ borderRadius: 5, marginBottom: 25 }}
      />
      <SkeletonBox
        height={250}
        width={"98%"}
        style={{ borderRadius: 5, marginBottom: 25 }}
      />
    </div>
  ) : (
    <>
      <div
        className="formWrapper"
        style={{
          height: window.innerHeight * 0.62,
          overflow: "auto",
          paddingRight: "1rem",
        }}
      >
        <fieldset className="formSection">
          <legend className="formSectionLegend">{LABELS.AGENCY_DETAILS}</legend>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"firmName"}
                type={"text"}
                label={LABELS.FIRM_NAME}
                //required={true}
                defaultValue={companyDetails.compName || ""}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30 ">
              <label>{LABELS.STATE}</label>
              <AutoComplete
                list={states}
                childRef={agencyDetailsStateRef}
                required={true}
                defaultValue={selectedAgencyState}
                onChange={onStateChange}
                //disabled={true}
              />
            </div>

            <div className="formGroup width30 ">
              <label>{LABELS.ZONE}</label>
              <AutoComplete
                list={zone}
                childRef={agencyDetailsZoneRef}
                required={true}
                defaultValue={
                  // currentDetails.zoneId
                  //   ? {
                  //       id: currentDetails.zoneId,
                  //       label: currentDetails.zone,
                  //     }
                  //   : null
                  selectedAgencyZone
                }
                // onChange={onStateChange}
                //disabled={true}
              />
            </div>

            {/* <div className="formGroup width30">
              <TxtRow
                id={"taluka"}
                type={"text"}
                label={LABELS.TALUKA}
                // required={true}
                defaultValue={companyDetails.compTaluka || ""}
                //disabled={isSubmit}
              />
            </div> */}
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30 ">
              <label>{LABELS.DISTRICT}</label>
              <AutoComplete
                list={district}
                childRef={agencyDetailsDistrictRef}
                required={true}
                defaultValue={
                  // companyDetails.compDistId
                  //   ? {
                  //       id: companyDetails.compDistId,
                  //       label: companyDetails.compDistName,
                  //     }
                  //   : null
                  selectedAgencyDistrict
                }
                onChange={onDistrictChange}

                //disabled={true}
              />
            </div>
            <div className="formGroup width30 ">
              <label>{LABELS.TALUKA}</label>
              <AutoComplete
                list={taluka}
                childRef={agencyTalukaRef}
                required={true}
                defaultValue={selectedAgencyTaluka}
                onChange={onTalukaChange}

                //disabled={true}
              />
            </div>

            <div className="formGroup width30 ">
              <label>{LABELS.CITY}</label>
              <AutoComplete
                list={city}
                childRef={agencyDetailsCityRef}
                required={true}
                defaultValue={selectedAgencyCity}
                // onChange={onStateChange}
                //disabled={true}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"population"}
                type={"number"}
                label={LABELS.POPULATION}
                //required={true}
                defaultValue={currentDetails.population || ""}
                //disabled={isSubmit}
              />
            </div>

            <div className="formGroup width30 ">
              <label>{LABELS.STATUS}</label>
              <RadioBtn
                list={[
                  {
                    id: "Proprietor",
                    value: "Proprietor",
                    label: LABELS.PROPRIETOR,
                    checked: selectedRow.companyDetails
                      ? companyDetails.firmType === "Proprietor"
                      : false,
                    disabled: false,
                  },
                  {
                    id: "Partnership",
                    value: "Partnership",
                    label: LABELS.PARTNERSHIP,
                    checked: selectedRow.companyDetails
                      ? companyDetails.firmType === "Partnership"
                      : false,
                    disabled: false,
                  },
                  {
                    id: "Pvt. Ltd",
                    value: "Pvt. Ltd",
                    label: LABELS.PVT_LTD,
                    checked: selectedRow.companyDetails
                      ? companyDetails.firmType === "Pvt. Ltd"
                      : false,
                    disabled: false,
                  },
                  {
                    id: "Ltd",
                    value: "Ltd.",
                    label: LABELS.LTD,
                    checked: selectedRow.companyDetails
                      ? companyDetails.firmType === "Ltd"
                      : false,
                    disabled: false,
                  },
                  {
                    id: "Llp",
                    value: "Llp.",
                    label: LABELS.LLP,
                    checked: selectedRow.companyDetails
                      ? companyDetails.firmType === "Llp"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"firmType"}
              />
            </div>
            <div className="formGroup width30"></div>
          </div>
        </fieldset>

        <fieldset className="formSection">
          <legend className="formSectionLegend">{LABELS.CONTACT_PERSON}</legend>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"fullName"}
                type={"text"}
                label={LABELS.FULL_NAME}
                disabled
                //required={true}
                defaultValue={
                  personalDetails.fName +
                    "  " +
                    personalDetails.midName +
                    "  " +
                    personalDetails.lName || " "
                }
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"mobileNo"}
                type={"number"}
                label={LABELS.LANDLINE_NUMBER}
                // required={true}
                defaultValue={personalDetails.phone || ""}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30"></div>
          </div>
        </fieldset>

        <fieldset className="formSection">
          <legend className="formSectionLegend">
            {LABELS.PHY_GODOWN_VERIFICATION}
          </legend>
          <div className="flexRowAround">
            <div className="formGroup width30 required">
              <label>
                {"Physical godown verification"}
                <span>{" *"}</span>
              </label>
              <RadioBtn
                list={[
                  {
                    id: "yes",
                    value: "yes",
                    label: LABELS.YES,
                    checked: selectedRow.godownVerificationDetails
                      ? godownVerificationDetails.GodownStatus === "yes"
                      : false,
                    disabled: false,
                  },
                  {
                    id: "no",
                    value: "no",
                    label: LABELS.NO,
                    checked: selectedRow.godownVerificationDetails
                      ? godownVerificationDetails.GodownStatus === "no"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"GodownStatus"}
              />
            </div>
            <div className="formGroup width30 required">
              <label>
                {LABELS.PHYSICAL_GODOWN_TYPE}
                <span>{" *"}</span>
              </label>
              <RadioBtn
                list={[
                  {
                    id: "own",
                    value: "own",
                    label: LABELS.OWN,
                    checked: selectedRow.godownVerificationDetails
                      ? godownVerificationDetails.OwnerStatus === "own"
                      : false,
                    disabled: false,
                  },
                  {
                    id: "rented",
                    value: "rented",
                    label: LABELS.RENTED,
                    checked: selectedRow.godownVerificationDetails
                      ? godownVerificationDetails.OwnerStatus === "rented"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"OwnerStatus"}
              />
            </div>
            <div className="formGroup width30 required">
              <TxtRow
                id={"godownSize"}
                type={"number"}
                label={LABELS.SIZE_OF_GODOWN}
                required={true}
                defaultValue={storageDetails.godownSize || ""}
                //disabled={isSubmit}
                placeholder={"Length ,Width ,Height"}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30 required">
              <label>
                {"Manpower Planning (Yes/No)"}
                <span>{" *"}</span>
              </label>
              <RadioBtn
                list={[
                  {
                    id: "yes",
                    value: "yes",
                    label: LABELS.YES,
                    checked: selectedRow.godownVerificationDetails
                      ? godownVerificationDetails.manPowerPlanning === "yes"
                      : false,
                    disabled: false,
                  },
                  {
                    id: "no",
                    value: "no",
                    label: LABELS.NO,
                    checked: selectedRow.godownVerificationDetails
                      ? godownVerificationDetails.manPowerPlanning === "no"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"manPowerPlanning"}
              />
            </div>
            <div className="formGroup width30 required">
              <label>
                {"Company / transport vehicle reachable to godown ?"}
                <span>{" *"}</span>
              </label>
              <RadioBtn
                list={[
                  {
                    id: "yes",
                    value: "yes",
                    label: LABELS.YES,
                    checked: selectedRow.accessVerificationDetails
                      ? accessVerificationDetails.AccessStatus === "yes"
                      : false,
                    disabled: false,
                  },
                  {
                    id: "no",
                    value: "no",
                    label: LABELS.NO,
                    checked: selectedRow.accessVerificationDetails
                      ? accessVerificationDetails.AccessStatus === "no"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"AccessStatus"}
              />
            </div>
            <div className="formGroup width30 ">
              <TxtRow
                id={"accessReason"}
                type={"text"}
                label={
                  "If No, reason for the same (wire obstruction, water clogging etc)"
                }
                // required={true}
                defaultValue={accessVerificationDetails.accessReason || ""}
                //disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30 required">
              <label>
                {LABELS.FILE_UPLOAD}
                <span>{" *"}</span>
                <small>
                  {" ( Max File Size: " + CONFIG.MAX_FILE_SIZE + " MB )"}
                </small>
              </label>
              <div className="flexRow">
                <div style={{ width: "95%" }} className="flexRow">
                  <TxtBox
                    type={"file"}
                    id="uploadFile"
                    // defaultValue={selectedRow.id ? selectedRow.fuelFiles : null}
                    // className="uploadFile"
                    accept="image/*,.pdf"
                    disabled={isButtonDisabled}
                    onChange={(e, f) => {
                      onUploadFile(e, f, "godownVerification");
                    }}
                  />
                </div>
                <IconButton
                  onClick={() => {
                    setGodownDemoDialog(true);
                  }}
                >
                  <Tooltip title={LABELS.DEMO_IMAGES} placement="bottom">
                    <InfoIcon />
                  </Tooltip>
                </IconButton>
              </div>
              <div
                className="formGroup"
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                }}
              >
                {storeVisitFiles &&
                  storeVisitFiles.map((u, i) => {
                    return (
                      <div
                        className="thumbnailBox width20"
                        key={"storefile-" + i}
                      >
                        <IconButton
                          disabled={isButtonDisabled}
                          className="thumbnailBoxIcon"
                          onClick={() => {
                            const list = storeVisitFiles.filter(
                              (a, j) => j !== i
                            );
                            setStoreVisitFiles(list);
                          }}
                        >
                          <IconClose />
                        </IconButton>
                        <img
                          onClick={() =>
                            window.open(
                              API_CONFIG.STATIC_URL + u.path,
                              "_blank"
                            )
                          }
                          src={
                            u.mimeType === "pdf"
                              ? thumbnailImg
                              : API_CONFIG.STATIC_URL + u.path
                          }
                          className="responsive cursor"
                        />
                      </div>
                    );
                  })}
                {uploading && (
                  <div className="thumbnailBox width20">
                    <SkeletonBox height={150} />
                  </div>
                )}
              </div>
            </div>
            <div className="formGroup width30"></div>
            <div className="formGroup width30"></div>
          </div>
        </fieldset>

        <fieldset className="formSection">
          <legend className="formSectionLegend">
            {LABELS.LOGISTICS_VERIFICATION}
          </legend>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <label>{"Do You Have Vehicle ?"}</label>
              <RadioBtn
                list={[
                  {
                    id: "yes",
                    value: "yes",
                    label: LABELS.YES,
                    checked: selectedRow.logisticsVerificationDetails
                      ? logisticsVerificationDetails.VehicalStatus === "yes"
                      : false,
                    disabled: false,
                  },
                  {
                    id: "no",
                    value: "no",
                    label: LABELS.NO,
                    checked: selectedRow.logisticsVerificationDetails
                      ? logisticsVerificationDetails.VehicalStatus === "no"
                      : false,
                    disabled: false,
                  },
                ]}
                onChange={(val) => {
                  setIsVehicle(val);
                }}
                row={true}
                name={"VehicalStatus"}
              />
            </div>
            {isVehicle === "yes" ? (
              <>
                <div className="formGroup width30">
                  <label>{"Physical vehicle verification"}</label>
                  <RadioBtn
                    list={[
                      {
                        id: "own",
                        value: "own",
                        label: LABELS.OWN,
                        checked: selectedRow.logisticsVerificationDetails
                          ? logisticsVerificationDetails.VehicleOwnerStatus ===
                            "own"
                          : false,
                        disabled: false,
                      },
                      {
                        id: "rented",
                        value: "rented",
                        label: LABELS.RENTED,
                        checked: selectedRow.logisticsVerificationDetails
                          ? logisticsVerificationDetails.VehicleOwnerStatus ===
                            "rented"
                          : false,
                        disabled: false,
                      },
                    ]}
                    row={true}
                    name={"VehicleOwnerStatus"}
                  />
                </div>
                <div className="formGroup width30">
                  <label>{"Physical vehicle verification"}</label>
                  <RadioBtn
                    list={[
                      {
                        id: "old",
                        value: "old",
                        label: LABELS.OLD,
                        checked: selectedRow.logisticsVerificationDetails
                          ? logisticsVerificationDetails.VehicleTypeStatus ===
                            "old"
                          : false,
                        disabled: false,
                      },
                      {
                        id: "new",
                        value: "new",
                        label: LABELS.NEW,
                        checked: selectedRow.logisticsVerificationDetails
                          ? logisticsVerificationDetails.VehicleTypeStatus ===
                            "new"
                          : false,
                        disabled: false,
                      },
                    ]}
                    row={true}
                    name={"VehicleTypeStatus"}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="formGroup width30"></div>{" "}
                <div className="formGroup width30"></div>
              </>
            )}
          </div>
          {isVehicle === "yes" && (
            <div className="flexRowAround">
              <div className="formGroup width30">
                <TxtRow
                  id={"noOfVehicle"}
                  type={"number"}
                  label={LABELS.NUMBER_OF_OWNED_VEHICLE}
                  // required={true}
                  defaultValue={logisticsVerificationDetails.noOfVehicle}
                  //disabled={isSubmit}
                />
              </div>
              <div className="formGroup width30">
                <TxtRow
                  id={"noOfRentedVehicle"}
                  type={"number"}
                  label={LABELS.NUMBER_OF_RENTED_VEHICLE}
                  // required={true}
                  defaultValue={
                    logisticsVerificationDetails.noOfRentedVehicle || ""
                  }
                  //disabled={isSubmit}
                />
              </div>
              <div className="formGroup width30">
                <TxtRow
                  id={"packBody"}
                  type={"text"}
                  label={LABELS.PACK_BODY}
                  // required={true}
                  defaultValue={logisticsVerificationDetails.packBody}
                  //disabled={isSubmit}
                />
              </div>
            </div>
          )}

          <div className="flexRowAround">
            <div className="formGroup width30">
              <label>
                {LABELS.FILE_UPLOAD}
                <small>
                  {" ( Max File Size: " + CONFIG.MAX_FILE_SIZE + " MB )"}
                </small>
              </label>
              <div className="flexRow">
                <div style={{ width: "95%" }} className="flexRow">
                  <TxtBox
                    type={"file"}
                    id="uploadFile"
                    // defaultValue={selectedRow.id ? selectedRow.fuelFiles : null}
                    // className="uploadFile"
                    accept="image/*,.pdf"
                    disabled={isButtonDisabled}
                    onChange={(e, f) => {
                      onUploadFile(e, f, "logisticVerification");
                    }}
                  />
                </div>
                <IconButton
                  onClick={() => {
                    setLogisticsDemoDialog(true);
                  }}
                >
                  <Tooltip title={LABELS.DEMO_IMAGES} placement="bottom">
                    <InfoIcon />
                  </Tooltip>
                </IconButton>
              </div>
              <div
                className="formGroup"
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                }}
              >
                {logisticsVerificationFiles &&
                  logisticsVerificationFiles.map((u, i) => {
                    return (
                      <div
                        className="thumbnailBox width20"
                        key={"storefile-" + i}
                      >
                        <IconButton
                          disabled={isButtonDisabled}
                          className="thumbnailBoxIcon"
                          onClick={() => {
                            const list = logisticsVerificationFiles.filter(
                              (a, j) => j !== i
                            );
                            setLogisticsVerificationFiles(list);
                          }}
                        >
                          <IconClose />
                        </IconButton>
                        <img
                          onClick={() =>
                            window.open(
                              API_CONFIG.STATIC_URL + u.path,
                              "_blank"
                            )
                          }
                          src={
                            u.mimeType === "pdf"
                              ? thumbnailImg
                              : API_CONFIG.STATIC_URL + u.path
                          }
                          className="responsive cursor"
                        />
                      </div>
                    );
                  })}
                {uploadingLogistic && (
                  <div className="thumbnailBox width20">
                    <SkeletonBox height={150} />
                  </div>
                )}
              </div>
            </div>
            <div className="formGroup width30"></div>
            <div className="formGroup width30"></div>
          </div>
        </fieldset>

        <fieldset className="formSection">
          <legend className="formSectionLegend">{"Tech Verification"}</legend>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <label>{"Does he have Computer/PC or Laptop ?"}</label>
              <RadioBtn
                list={[
                  {
                    id: "yes",
                    value: "yes",
                    label: LABELS.YES,
                    checked: selectedRow.techVerificationDetails
                      ? techVerificationDetails.TechStatus === "yes"
                      : false,
                    disabled: false,
                  },
                  {
                    id: "no",
                    value: "no",
                    label: LABELS.NO,
                    checked: selectedRow.techVerificationDetails
                      ? techVerificationDetails.TechStatus === "no"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"TechStatus"}
              />
            </div>

            <div className="formGroup width30">
              <label>{"Does he have  Printer?"}</label>
              <RadioBtn
                list={[
                  {
                    id: "yes",
                    value: "yes",
                    label: LABELS.YES,
                    checked: selectedRow.techVerificationDetails
                      ? techVerificationDetails.printerStatus === "yes"
                      : false,
                    disabled: false,
                  },
                  {
                    id: "no",
                    value: "no",
                    label: LABELS.NO,
                    checked: selectedRow.techVerificationDetails
                      ? techVerificationDetails.printerStatus === "no"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"printerStatus"}
              />
            </div>
            <div className="formGroup width30">
              <label>
                {"Will he be able to work on our online order system? "}
              </label>
              <RadioBtn
                list={[
                  {
                    id: "yes",
                    value: "yes",
                    label: LABELS.YES,
                    checked: selectedRow.techVerificationDetails
                      ? techVerificationDetails.OnlineStatus === "yes"
                      : false,
                    disabled: false,
                  },
                  {
                    id: "no",
                    value: "no",
                    label: LABELS.NO,
                    checked: selectedRow.techVerificationDetails
                      ? techVerificationDetails.OnlineStatus === "no"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"OnlineStatus"}
              />
            </div>
          </div>

          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"onlineDate"}
                type={"date"}
                label={
                  " If No, when he will be able to work on online order system"
                }
                // required={true}
                defaultValue={
                  selectedRow.techVerificationDetails
                    ? DateFunctions.getFormatedDate(
                        selectedRow.techVerificationDetails,

                        FORMATS.SQL_DATE,

                        FORMATS.SQL_DATE_ONLY
                      )
                    : DateFunctions.getDate(
                        "today",

                        "from",

                        FORMATS.SQL_DATE_ONLY
                      )
                }
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <label>
                {"weekly order schedule or bi-weekly order schedule?"}
              </label>
              <RadioBtn
                list={[
                  {
                    id: "Weekly",
                    value: "Weekly",
                    label: "Weekly",
                    checked: selectedRow.techVerificationDetails
                      ? techVerificationDetails.WeeklyStatus === "Weekly"
                      : false,
                    disabled: false,
                  },
                  {
                    id: "Bi-Weekly",
                    value: "Bi-Weekly",
                    label: "Bi-Weekly",
                    checked: selectedRow.techVerificationDetails
                      ? techVerificationDetails.WeeklyStatus === "Bi-Weekly"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"WeeklyStatus"}
              />
            </div>

            <div className="formGroup width30"></div>
          </div>
        </fieldset>

        <fieldset className="formSection">
          <legend className="formSectionLegend">
            {"Work Mode Verification"}
          </legend>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <label>{"Will he work exclusively for GSL ?"}</label>
              <RadioBtn
                list={[
                  {
                    id: "yes",
                    value: "yes",
                    label: LABELS.YES,
                    checked: selectedRow.workModeVerificationDetails
                      ? workModeVerificationDetails.WorkModeStatus === "yes"
                      : false,
                    disabled: false,
                  },
                  {
                    id: "no",
                    value: "no",
                    label: LABELS.NO,
                    checked: selectedRow.workModeVerificationDetails
                      ? workModeVerificationDetails.WorkModeStatus === "no"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"WorkModeStatus"}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"workCondition"}
                type={"text"}
                label={
                  "If no, at what conditions he will convert to exclusive dealer?"
                }
                // required={true}
                defaultValue={workModeVerificationDetails.workCondition || ""}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"agencyName"}
                type={"text"}
                label={"Name of agency/Business/Products (Other than GSL)"}
                // required={true}
                defaultValue={workModeVerificationDetails.agencyName || ""}
                //disabled={isSubmit}
              />
            </div>
          </div>

          <div className="flexRowAround">
            <div className="formGroup width30">
              <label>
                {"Will he be dedicated person to handle the business  ?"}
              </label>
              <RadioBtn
                list={[
                  {
                    id: "yes",
                    value: "yes",
                    label: LABELS.YES,
                    checked: selectedRow.financeVerificationDetails
                      ? financeVerificationDetails.BusinessStatus === "yes"
                      : false,
                    disabled: false,
                  },
                  {
                    id: "no",
                    value: "no",
                    label: LABELS.NO,
                    checked: selectedRow.financeVerificationDetails
                      ? financeVerificationDetails.BusinessStatus === "no"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"BusinessStatus"}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"familyMembers"}
                type={"number"}
                label={"How many family members will work in the business"}
                // required={true}
                defaultValue={financeVerificationDetails.familyMembers || ""}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30"></div>
          </div>
        </fieldset>

        <fieldset className="formSection">
          <legend className="formSectionLegend">
            {"Finance Verification"}
          </legend>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <label>{"Is he financially sound to do business or not ?"}</label>
              <RadioBtn
                list={[
                  {
                    id: "yes",
                    value: "yes",
                    label: LABELS.YES,
                    checked: selectedRow.financeVerificationDetails
                      ? financeVerificationDetails.FinanceStatus === "yes"
                      : false,
                    disabled: false,
                  },
                  {
                    id: "no",
                    value: "no",
                    label: LABELS.NO,
                    checked: selectedRow.financeVerificationDetails
                      ? financeVerificationDetails.FinanceStatus === "no"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"FinanceStatus"}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"investCapacity"}
                type={"number"}
                label={"Investment capacity (Working Capital) "}
                // required={true}
                defaultValue={financeVerificationDetails.investCapacity || ""}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"yearly"}
                type={"text"}
                label={"Other source of income Yearly"}
                // required={true}
                defaultValue={financeVerificationDetails.yearly || ""}
                //disabled={isSubmit}
              />
            </div>
          </div>
        </fieldset>

        <fieldset className="formSection">
          <legend className="formSectionLegend">{"First Order Detail"}</legend>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"firstOrderName"}
                type={"text"}
                label={"Name"}
                // required={true}
                defaultValue={assignedInfo.assignedToUser || ""}
                disabled={true}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"firstOrderDate"}
                type={"date"}
                label={"Date"}
                // required={true}
                defaultValue={
                  firstOrderDetails.firstOrderDate
                    ? DateFunctions.getFormatedDate(
                        firstOrderDetails.firstOrderDate,

                        FORMATS.SQL_DATE,

                        FORMATS.SQL_DATE_ONLY
                      )
                    : DateFunctions.getDate(
                        "today",
                        "from",
                        FORMATS.SQL_DATE_ONLY
                      )
                }
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"firstOrderDesignantion"}
                type={"text"}
                label={"Designation"}
                // required={true}
                defaultValue={assignedInfo.assignedToUserDesignantion || ""}
                disabled={true}
              />
            </div>
          </div>
        </fieldset>
        {/* 
        <div className="flexRow">
          <div className="formGroup width60">
            <TxtRow
              id={"remarks"}
              type={"text"}
              label={LABELS.REMARKS}
              // required={true}
              defaultValue={selectedRemarks.fieldVisit || " "}
              //disabled={isSubmit}
              rows={4}
            />
          </div>
        </div> */}
        <Comments
          selectedRow={selectedRow}
          isButtonDisabled={isButtonDisabled}
          remarksList={remarksList}
          getCrmRemarks={getCrmRemarks}
          remarksLoading={remarksLoading}
          setRemarksLoading={setRemarksLoading}
        />
        {/* {isApproved === null && (
          <StatusButtons
            isButtonDisabled={isButtonDisabled}
            selectedRow={selectedRow}
            onClose={onClose}
            page={CRM_LEAD_STATUS.FIELD_VISIT}
          />
        )} */}
      </div>

      {godownDemoDialog && (
        <UiDialog
          open={true}
          title={LABELS.DEMO_IMAGES + " for " + LABELS.PHY_GODOWN_VERIFICATION}
          size={"lg"}
          onClose={() => setGodownDemoDialog(false)}
        >
          <div className="flexRowAround">
            <img
              src="https://5.imimg.com/data5/GU/KT/LG/SELLER-58537408/alphabet-snacks-pellets-500x500.jpg"
              width="30%"
              height="30%"
            />
            <img
              src="data:image/jpeg;base64,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"
              width="30%"
              height="30%"
            />
          </div>
        </UiDialog>
      )}

      {logisticsDemoDialog && (
        <UiDialog
          open={true}
          title={LABELS.DEMO_IMAGES + " for " + LABELS.LOGISTICS_VERIFICATION}
          size={"sm"}
          onClose={() => setLogisticsDemoDialog(false)}
        >
          <div className="flexRowAround">
            <img
              src="https://5.imimg.com/data5/GU/KT/LG/SELLER-58537408/alphabet-snacks-pellets-500x500.jpg"
              width="30%"
              height="30%"
              alt={LABELS.DEMO_IMAGES}
            />
            <img
              src="data:image/jpeg;base64,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"
              width="30%"
              height="30%"
            />
          </div>
        </UiDialog>
      )}
      {mandatoryResults.length > 0 && (
        <div className="mandatoryBox">
          <ul>
            {mandatoryResults.map((m) => {
              return (
                <li>
                  <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                </li>
              );
            })}
          </ul>
        </div>
      )}

      {/* BtmMenu */}
      <div className="formGroup submitBtnWrapper">
        <div className=" flexRowAround">
          <Btn
            text={LABELS.SAVE}
            loading={isSubmit}
            onClick={saveRecord}
            bgColor={COLORS.SAVE_GREEN}
            disabled={isButtonDisabled}
            // isButtonDisabled
          />
        </div>
      </div>
    </>
  );
};

export default withSnackbar(NewDealer);
